// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import AutocompleteController from "./autocomplete_controller"
application.register("autocomplete", AutocompleteController)

import CharCounterController from "./char_counter_controller"
application.register("char-counter", CharCounterController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ColorModeController from "./color_mode_controller"
application.register("color-mode", ColorModeController)

import DropdownPopoverController from "./dropdown_popover_controller"
application.register("dropdown-popover", DropdownPopoverController)

import EntryOrSourceSelectController from "./entry_or_source_select_controller"
application.register("entry-or-source-select", EntryOrSourceSelectController)

import EntryPreviewTriggerController from "./entry_preview_trigger_controller"
application.register("entry-preview-trigger", EntryPreviewTriggerController)

import ImageViewerCallerController from "./image_viewer_caller_controller"
application.register("image-viewer-caller", ImageViewerCallerController)

import ImagesCarouselController from "./images_carousel_controller"
application.register("images-carousel", ImagesCarouselController)

import MapController from "./map_controller"
application.register("map", MapController)

import MenuController from "./menu_controller"
application.register("menu", MenuController)

import ModalCallerController from "./modal_caller_controller"
application.register("modal-caller", ModalCallerController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NavMenuController from "./nav_menu_controller"
application.register("nav-menu", NavMenuController)

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)

import RadioNavigationController from "./radio_navigation_controller"
application.register("radio-navigation", RadioNavigationController)

import ScrollToController from "./scroll_to_controller"
application.register("scroll-to", ScrollToController)

import SearchMapController from "./search_map_controller"
application.register("search-map", SearchMapController)

import SelectController from "./select_controller"
application.register("select", SelectController)

import SlideoverController from "./slideover_controller"
application.register("slideover", SlideoverController)

import UnpersistedSubElementLinksListController from "./unpersisted_sub_element_links_list_controller"
application.register("unpersisted-sub-element-links-list", UnpersistedSubElementLinksListController)

import VisibilityTogglerController from "./visibility_toggler_controller"
application.register("visibility-toggler", VisibilityTogglerController)
